import { getPreviewUrl } from "constants/path"
import moment from "moment";
import "moment-timezone";

const getEventImageUrl = (xmlString) => {
  var doc = new DOMParser().parseFromString(xmlString, "text/html");
  var imgElement = doc.querySelector('img[alt="Feature Image"]') || doc.querySelector('img[alt="banner"]');
  return imgElement ? imgElement.src : ""
}

function urlify(text, id, orgColors) {
  let _linkColor = orgColors ? orgColors.linkColor : '#26BBED';
  text = text.replace(/<\/br>/g, " </br> ")
  var urlRegex = /(https?:\/\/[^\s]+)/g;
  return text.replace(urlRegex, function (url) {
    let href = (url.startsWith("https://qa.hyly.us/mktg/ev/") || url.startsWith("https://my.hyly.us/mktg/ev") || url.startsWith("https://my.hy.ly/mktg/ev")) ? getPreviewUrl(id) : url.replace('</br>', '');
    return '<a style="color:' + _linkColor + '" href="' + href + '">' + url + '</a>';
  })
}


const parseStringToHtml = (str, id, orgColors) => {
  if (!str) return ""
  str = str.replace(/(?:\r\n|\r|\n)/g, '</br>');
  return urlify(str, id, orgColors)
}
const getWidth = (isDrawerOpen) => {
  return {
    0: {
      Desktop: 1230,
      Mobile: 1170,
    },
    1: {
      Desktop: isDrawerOpen ? 1230 : 1520,
      Mobile: 843
    },
    2: {
      email: 843,
    },
    3: {
      print: 1170,
      download: 1170,
    }
  }
}
//

const createPreviewHtml = (xmlString) => {
  var doc = new DOMParser().parseFromString(xmlString, "text/html");
  var imgElement = doc.querySelector('img[alt="Feature Image"]') || doc.querySelector('img[alt="banner"]');
  var logoElement = doc.querySelector('img[alt="Logo"]') || doc.querySelector('img[alt="property-logo"]')
  var subjectElement = doc.querySelector('p[hyly-label="Subject"]') || doc.querySelector('div[class="n-subject"]') || doc.querySelector('div[hyly-edit="subject_text"]')
  var titleElement = doc.querySelector('p[hyly-label="Title"]') || doc.querySelector('div[class=" n-title title_text"]') || doc.querySelector('div[class="n-title"]')

  const html = `<html>
    <body>
        <div style="max-width: 200px;background:white">
            <img style="max-width: 100px;margin: auto;display: block;padding: 7px 0px;" src=${logoElement ? logoElement.src : ""} />
            <div style="    margin: auto;width: fit-content;text-align: center;padding-top: 5px;font-size: 16px;">${subjectElement ? subjectElement.innerHTML.trim() : ""}</div>
            <div style="margin: auto;width: fit-content;text-align: center;padding-top: 5px;font-size: 14px;">${titleElement ? titleElement.innerHTML.trim() : ""} </div>
            <img style="max-width: 185px;padding-top: 10px;" src=${imgElement ? imgElement.src : ""}  />
      </div>
    </body>
</html>`
  return html
}

const getEmailsGroup = (props) => {
  const emailsWithName = {
    invite_email: {
      emailName: "Event Invite",
      graphqlKey: "enableInviteEmail",
      active: props.enableInviteEmail,
      tooltip: {
        sentTo: "All the invitees",
        when: "User scheduled date & time",
        sentBy: "User",
      },
    },
    cancel_email: {
      emailName: "Event Canceled",
      graphqlKey: "enableCancelEmail",
      active: props.enableCancelEmail,
      tooltip: {
        sentTo: "All the RSVPed List",
        when: "When event canceled",
        sentBy: "Artie",
      },
    },
    reschedule_email: {
      emailName: "Event Rescheduled",
      graphqlKey: "enableRescheduleEmail",
      active: props.enableRescheduleEmail,
      tooltip: {
        sentTo: "All the invitees",
        when: "When event rescheduled",
        sentBy: "Artie",
      },
    },
    night_reminder_email: {
      emailName: "Night Reminder",
      graphqlKey: "enableNightReminderEmail",
      active: props.enableNightReminderEmail,
      tooltip: {
        sentTo: "All the RSVPed List",
        when: "9pm - Event’s before day",
        sentBy: "Artie",
      },
    },
    morning_reminder_email: {
      emailName: "Morning Reminder",
      graphqlKey: "enableMorningReminderEmail",
      active: props.enableMorningReminderEmail,
      tooltip: {
        sentTo: "All the invitees",
        when: "9am - Event’s before day",
        sentBy: "Artie",
      },
    },
    follow_up_email: {
      emailName: "Follow Up",
      graphqlKey: "enableFollowUpEmail",
      active: props.enableFollowUpEmail,
      tooltip: {
        sentTo: "All the invitees",
        when: "9am - Event’s next day",
        sentBy: "Artie",
      },
    },
    rsvped: {
      emailName: "Confirmation",
      graphqlKey: "enableRsvpedEmail",
      active: props.enableRsvpedEmail,
      tooltip: {
        sentTo: "Contact who RSVPed",
        when: "When RSVP confirmed",
        sentBy: "Artie",
      },
    },
    rsvp_cancelled: {
      emailName: "RSVP Cancel",
      graphqlKey: "enableRsvpCancelledEmail",
      active: props.enableRsvpCancelledEmail,
      tooltip: {
        sentTo: "Contact who canceled RSVP",
        when: "When RSVP canceled",
        sentBy: "Artie",
      },
    },
    waitlisted: {
      emailName: "Waitlisted",
      graphqlKey: "enableWaitlistedEmail",
      active: props.enableWaitlistedEmail,
      tooltip: {
        sentTo: "Contacts who joined waitlist",
        when: "When waitlist opened",
        sentBy: "Artie",
      },
    },
    waitlist_opening: {
      emailName: "Waitlist Opening",
      graphqlKey: "enableWaitlistOpeningEmail",
      active: props.enableWaitlistOpeningEmail,
      tooltip: {
        sentTo: "All the waitlisted contacts",
        when: "When waitlist opened",
        sentBy: "Artie",
      },
    },
    thank_you: {
      emailName: "Thank you",
      graphqlKey: "enableThankYouEmail",
      active: props.enableThankYouEmail,
      tooltip: {
        sentTo: "All the attendees",
        when: "10am Next day from when the attendance is marked",
        sentBy: "Artie",
      },
    },
  };
  const emailsDetails = JSON.parse(props.emailList);
  const notifications = [];
  const reminders = [];
  const confirmations = [];
  for (let i = 0; i < emailsDetails.length; i++) {
    const prevHtml = createPreviewHtml(emailsDetails[i].html)
    if (emailsDetails[i].group == "Notifications" && emailsDetails[i].campaign != 'follow_up_email') {
      notifications.push({
        ...emailsDetails[i],
        prevHtml,
        ...emailsWithName[emailsDetails[i].campaign]

      })
    }
    if (emailsDetails[i].group == "Reminders") {
      reminders.push({
        ...emailsDetails[i],
        prevHtml,
        ...emailsWithName[emailsDetails[i].campaign]
      })
    }
    if (emailsDetails[i].group == "RSVP Confirmations") {
      confirmations.push({
        ...emailsDetails[i],
        prevHtml,
        ...emailsWithName[emailsDetails[i].campaign]
      })
    }
  }
  return {
    notifications,
    reminders,
    confirmations
  }
}

const parseBody = (text) => {
  var newL = /\n/g;
  let _text = text.replace(newL, '');
  return _text.replace(/"/g, '');
}

const getUpdatedValue = (time, timezoneString) => {
  let updatedTime = moment(time).tz(timezoneString);
  let currentTime = moment().tz(timezoneString);
  return currentTime.diff(updatedTime, 'days')
}

export {
  parseStringToHtml,
  urlify,
  getWidth,
  getEmailsGroup,
  getUpdatedValue,
  getEventImageUrl,
  parseBody
}